<template>
  <div class="fapi-form-basic-block">
    <div
      class="f-px-2 f-py-3 f-flex f-font-semibold f-relative f-justify-between f-items-center fapi-container-header"
      v-bind:class="{
        'order-bump f-py-2': orderBump,
      }"
    >
      <div
        class="fapi-form-basic-block-title f-w-full f-text-center"
        v-bind:class="{
          'order-bump-title': orderBump,
        }"
      >
        <div v-if="title">{{ title }}</div>
      </div>
      <div class="fapi-form-basic-block-title-after f-absolute f-right-0">
        <slot name="titleAfter"></slot>
      </div>
    </div>
    <div class="f-p-6" :class="{ 'order-bump-content': orderBump }">
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "BasicBlock",

  props: {
    title: {
      type: [String, Boolean],
      default: false,
    },
    simple: {
      type: Boolean,
      default: false,
    },
    orderBump: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<style lang="scss">
.fapi-order-form {
  .order-bump {
    background-color: var(
      --order-bump-container-header-background-color
    ) !important;
    font-size: var(--order-bump-container-header-font-size) !important;
    color: var(--order-bump-container-header-color) !important;
  }

  .order-bump-content {
    border-right: var(--order-bump-border-style);
    border-bottom: var(--order-bump-border-style);
    border-left: var(--order-bump-border-style);
    margin-bottom: 1em;
    background-color: var(--order-bump-container-content-background-color);
    padding: var(--order-bump-space-padding) !important;
  }
}
</style>
